import { React, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { SectionEmbudo } from "./SectionEmbudo";
import { TablaEmbudo } from "./TablaEmbudo";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import FiltroEmbudoVentas from "./FiltroEmbudoVentas";
import { useBox } from "../../Finanzas/Helper/useBox";
import { FiltroTiempoRealSection } from "./FiltroTiempoRealSection";
import { number, use } from "echarts";
import { GetKey } from "../../Finanzas/Actions/GetContainer";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";

export const EmbudoVentasScreen = () => {
  const history = useHistory();
  const [visualizacion, setVisualizacion] = useState("sucursal");
  const [region, setRegion] = useState("0");
  const [sucursal, setSucursal] = useState("0");
  const [verpor, setVerpor] = useState("unidades");
  const [rol, setRol] = useState(0);
  const [embudoData, setEmbudoData] = useState([]);
  const [regionesData, setRegionesData] = useState([]);
  const [sucursalesData, setSucursalesData] = useState([]);
  const [lineasData, setLineasData] = useState([]);
  const [departamentosData, setDepartamentosData] = useState([]);
  const [asesoresData, setAsesoresData] = useState([]);
  const [fasesAplicadas, setFasesAplicadas] = useState([]);
  const [lineaAplicada, setLineaAplicada] = useState();
  const [cultivoAplicado, setCultivoAplicado] = useState();
  const [titulo, setTitulo] = useState('EMBUDO DE VENTAS');
  const [leyenda, setLeyenda] = useState('Embudo de ventas');
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const fechaInicio = new Date(currentYear, currentMonth - 1, 1)
    .toISOString()
    .split("T")[0];
  const fechaFin = today.toISOString().split("T")[0];

  const initialStateboxfiltros = () => {
    return {
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
      linea: 0,
      esquema: -999,
      cultivo: 'Consolidado',
      fase: []
    };
  };

  const [boxstate, setBoxState] = useBox(initialStateboxfiltros());

  useEffect(() => {
    onExecute(
      boxstate.fechaInicio,
      boxstate.fechaFin,
      boxstate.esquema,
      boxstate.linea,
      boxstate.cultivo
    );
  }, []);

  const onExecute = (
    fecha_inicio,
    fecha_fin,
    esquema,
    linea,
    cultivo
  ) => {
    let fase = GetKey(boxstate?.faseSelect?.map(f => ({ faseSelect: f })), ["faseSelect"]);
    if (fase === undefined || fase === null || fase === "") {
      fase = "CC";
    }
    setFasesAplicadas(boxstate?.faseSelect ?? []);
    setLineaAplicada(boxstate?.linea);
    setCultivoAplicado(boxstate?.cultivo);

    const [anioI, mesI, diaI] = fecha_inicio.split("-").map(Number);
    const [anioF, mesF, diaF] = fecha_fin.split("-").map(Number);

    const fechaI = new Date(anioI, mesI - 1, diaI);
    const fechaF = new Date(anioF, mesF - 1, diaF)

    const mesInicio = GetMonthNameByNumber(fechaI.getMonth() + 1).toUpperCase();
    const mesFin = GetMonthNameByNumber(fechaF.getMonth() + 1).toUpperCase();
    const anioInicio = fechaI.getFullYear();
    const anioFin = fechaF.getFullYear();
    const diaInicio = fechaI.getDate().toString().padStart(2, "0");
    const diaFin = fechaF.getDate().toString().padStart(2, "0");

    let rangoFechas = "";
    let tituloPeriodo = "";
    if (anioInicio === anioFin) {
      if (mesI === mesF) {
        if (diaInicio === diaFin) {
          tituloPeriodo =
            `${diaInicio} DE ${mesInicio} ${anioFin}`;
        }
        else {
          tituloPeriodo =
            `DEL ${diaInicio} AL ${diaFin} DE ${mesInicio} ${anioFin}`;
        }
      } else {
        tituloPeriodo =
          `DEL ${diaInicio} DE ${mesInicio} AL ${diaFin} DE ${mesFin} ${anioFin}`;
      }
    } else {
      tituloPeriodo =
        `DEL ${diaInicio} DE ${mesInicio} ${anioInicio} AL ${diaFin} DE ${mesFin} ${anioFin}`;
    }

    const tituloP = `EMBUDO DE VENTAS ${tituloPeriodo}`;

    setTitulo(tituloP);
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      const peticion = `EmbudoVentas/ObtenerEmbudoVentas?fecha_inicio=${boxstate.fechaInicio}&fecha_fin=${boxstate.fechaFin}&esquema=${esquema}&fase=${fase}&linea=${linea}&cultivo=${cultivo}`;
      request
        .get(peticion)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setRol(result?.permiso.rol);
          setEmbudoData(result?.data);
          setRegionesData(result?.regiones);
          setSucursalesData(result?.sucursales);
          setLineasData(result?.lineas);
          setDepartamentosData(result?.departamentos);
          setAsesoresData(result?.asesores);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          const mensaje =
            error?.response?.data ||
            error?.Mensaje ||
            "Error al cargar las cotizaciones.";
          Swal.fire("Cotización", mensaje, "error");
          return;
        });
    });
  };

  const generarLeyenda = () => {
    let visualizaciontext = "";
    if (visualizacion === "sucursal") {
      visualizaciontext = "por sucursal"
    } else if (visualizacion === "asesor") {
      visualizaciontext = "por asesor"
    }

    let nombreLinea = "";
    if (lineaAplicada && Number(lineaAplicada) !== 0) {
      const lineaObj = lineasData.find(x => Number(x.idlinea) === Number(lineaAplicada));
      if (lineaObj) nombreLinea = lineaObj.linea;
    }

    let textoUbicacion = "a nivel grupo";

    if (visualizacion === "sucursal") {
      if (Number(region) !== 0) {
        const reg = regionesData.find(r => Number(r.idestado) === Number(region));
        if (reg) textoUbicacion = `de la región ${capitalizePalabras(reg.region)}`;
      }
    }

    if (visualizacion === "asesor") {
      if (Number(sucursal) !== 0) {
        const suc = sucursalesData.find(s => Number(s.idsucursal) === Number(sucursal));
        if (suc) textoUbicacion = `de la sucursal ${capitalizePalabras(suc.sucursal)}`;
      } else if (Number(region) !== 0) {
        const reg = regionesData.find(r => Number(r.idestado) === Number(region));
        if (reg) textoUbicacion = `de la región ${capitalizePalabras(reg.region)}`;
      }
    }

    let textoVerPor = "";
    switch (verpor) {
      case "unidades":
        textoVerPor = "mostrado por unidades.";
        break;
      case "montos":
        textoVerPor = "mostrado por importes.";
        break;
      default:
        textoVerPor = "mostrado por unidades e importes.";
        break;
    }

    let textoCultivo = "";
    if (
      cultivoAplicado &&
      cultivoAplicado !== "0" &&
      cultivoAplicado !== "" &&
      cultivoAplicado !== "Consolidado" &&
      cultivoAplicado !== "Sin cultivo seleccionado"
    ) {
      textoCultivo = `, del cultivo ${cultivoAplicado}`;
    }

    const texto =
      Number(lineaAplicada) === 0
        ? `Embudo de ventas ${visualizaciontext} ${textoUbicacion}${textoCultivo}, ${textoVerPor}`
        : `Embudo de ventas ${visualizaciontext} de la linea de ${nombreLinea.toLowerCase()} ${textoUbicacion}${textoCultivo} ${textoVerPor}`;

    return texto;
  };
  // console.log(lineaAplicada)

  const fasesMap = {
    PR: "Promoción",
    IN: "Interés",
    NE: "Negociación",
    CE: "Cerrada",
    FM: "Facturar mes",
    FS: "Facturar semana",
    NC: "No compró",
    VP: "Venta perdida",
    VN: "Vendido",
  };

  useEffect(() => {
    setLeyenda(generarLeyenda());
  }, [lineaAplicada, region, sucursal, visualizacion, verpor, lineasData, regionesData, sucursalesData]);

  const datosFiltrados = embudoData.filter((x) => {
    const coincideRegion = Number(region) === 0 || Number(x.idestado) === Number(region);
    const coincideSucursal =
      visualizacion === "sucursal"
        ? true
        : Number(sucursal) === 0 || Number(x.idsucursal) === Number(sucursal);
    return coincideRegion && coincideSucursal
  });

  const datosAgrupados = datosFiltrados.reduce((acc, curr) => {
    const faseNombre = fasesMap[curr.fase] || curr.fase;
    const columna = visualizacion === "asesor" ? curr.asesor : curr.sucursal;

    const existente = acc.find(
      (item) => item.fase === faseNombre && item.linea === curr.linea && item.columna === columna
    );

    if (existente) {
      existente.cantidad += 1;
      existente.monto += Number(curr.monto) || 0;
    } else {
      acc.push({
        fase: faseNombre,
        linea: curr.linea,
        columna,
        cantidad: 1,
        monto: Number(curr.monto) || 0,
      });
    }

    return acc;
  }, []);

  const fasesAIncluir = fasesAplicadas.length > 0
    ? fasesAplicadas.map((f) => fasesMap[f] || f)
    : Object.values(fasesMap);

  const columnas =
    visualizacion === "asesor"
      ? asesoresData
        .filter(a =>
          (Number(region) === 0 || Number(a.idestado) === Number(region)) &&
          (Number(sucursal) === 0 || Number(a.idsucursal) === Number(sucursal))
        )
        .sort((a, b) => a.idsucursal - b.idsucursal)   // 👈 ORDEN POR ID
        .map(a => a.asesor)
      : sucursalesData
        .filter(s =>
          Number(region) === 0 || Number(s.idestado) === Number(region)
        )
        .sort((a, b) => {
          const lastA = Number(String(a.idsucursal).slice(-1));
          const lastB = Number(String(b.idsucursal).slice(-1));

          // prioridad: terminan en 1 primero, luego 2
          if (lastA === 1 && lastB !== 1) return -1;
          if (lastA !== 1 && lastB === 1) return 1;

          if (lastA === 2 && lastB !== 2) return -1;
          if (lastA !== 2 && lastB === 2) return 1;

          // si ninguno cumple, orden normal
          return a.idsucursal - b.idsucursal;
        })
        .map(s => s.sucursal);

  // console.log(columnas)

  const lineas =
    datosFiltrados.length > 0
      ? [...new Set(datosFiltrados.map((x) => x.linea))]
      : [...new Set(lineasData.map((l) => l.linea))];

  fasesAIncluir.forEach((fase) => {
    columnas.forEach((columna) => {
      lineas.forEach((linea) => {
        const existe = datosAgrupados.some(
          (d) => d.fase === fase && d.columna === columna && d.linea === linea
        );
        if (!existe) {
          datosAgrupados.push({
            fase,
            linea,
            columna,
            cantidad: 0,
            monto: 0
          });
        }
      });
    });
  });

  const ordenFases = fasesAplicadas.length > 0
    ? fasesAplicadas.map(f => fasesMap[f] || f)
    : Object.values(fasesMap);

  datosAgrupados.sort((a, b) => {
    const indexA = ordenFases.indexOf(a.fase);
    const indexB = ordenFases.indexOf(b.fase);
    return indexA - indexB;
  });

  datosAgrupados.sort((a, b) => {
    const indexA = columnas.indexOf(a.columna);
    const indexB = columnas.indexOf(b.columna);
    return indexA - indexB;
  });

  const datosFiltradosPorFase =
    fasesAplicadas.length === 0
      ? datosAgrupados
      : datosAgrupados.filter((item) =>
        fasesAplicadas.some((f) => fasesMap[f] === item.fase)
      );

  const lineasDisponibles = [
    ...new Map(
      lineasData?.map((x) => [x.linea, x])
    ).values()
  ].map((l, i) => ({
    codigo: i + 1,
    nombre: l.linea,
    icono: l.icono
  }));

  const onGeneraExcel = (fecha_inicio, fecha_fin) => {
    const [anioI, mesI, diaI] = fecha_inicio.split("-").map(Number);
    const [anioF, mesF, diaF] = fecha_fin.split("-").map(Number);

    const fechaI = new Date(anioI, mesI - 1, diaI);
    const fechaF = new Date(anioF, mesF - 1, diaF)

    const mesInicio = GetMonthNameByNumber(fechaI.getMonth() + 1).toUpperCase();
    const mesFin = GetMonthNameByNumber(fechaF.getMonth() + 1).toUpperCase();
    const anioInicio = fechaI.getFullYear();
    const anioFin = fechaF.getFullYear();
    const diaInicio = fechaI.getDate().toString().padStart(2, "0");
    const diaFin = fechaF.getDate().toString().padStart(2, "0");

    let rangoFechas = "";
    let tituloPeriodo = "";
    if (anioInicio === anioFin) {
      if (mesI === mesF) {
        if (diaInicio === diaFin) {
          tituloPeriodo =
            `${diaInicio} DE ${mesInicio} ${anioFin}`;
        }
        else {
          tituloPeriodo =
            `DEL ${diaInicio} AL ${diaFin} DE ${mesInicio} ${anioFin}`;
        }
      } else {
        tituloPeriodo =
          `DEL ${diaInicio} DE ${mesInicio} AL ${diaFin} DE ${mesFin} ${anioFin}`;
      }
    } else {
      tituloPeriodo =
        `DEL ${diaInicio} DE ${mesInicio} ${anioInicio} AL ${diaFin} DE ${mesFin} ${anioFin}`;
    }

    const tituloP = `EMBUDO DE VENTAS ${tituloPeriodo}`;
    const post = {
      titulo: tituloP,
      verPor: verpor,
      datos: datosFiltradosPorFase.map(d => ({
        fase: d.fase,
        linea: d.linea,
        columna: d.columna,
        cantidad: d.cantidad,
        monto: d.monto
      })),
      columnas: columnas,
      lineas: lineasDisponibles.map(l => l.nombre),
      fases: fasesAplicadas.length > 0
        ? fasesAplicadas.map(f => fasesMap[f] || f)
        : Object.values(fasesMap),

      sucursales: columnas
    };

    setLoader({ ...loader, mostrar: true });
    request.post(
      "EmbudoVentas/ImprimirExcelReporte", post
    )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("EMBUDO DE VENTAS", JSON.stringify(error), "error");
      });
  };

  return (
    <PlantillaScreen
      titulo={titulo}
      className={"plantilla_embudo_Ventas"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="peb-actions">
        <div
          className="peb-actions-regresar"

          onClick={() => {
            history.push("/Ventas/Main")
          }}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="peb-actions-filtro">
          <FiltroEmbudoVentas
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
          />
        </div>

        <div className="buttons">
          <button
            className="excel"
            onClick={() =>
              onGeneraExcel(boxstate.fechaInicio, boxstate.fechaFin)
            }
          >
            <i className=" icon-file-excel" /> Excel
          </button>
        </div>
      </div>
      {regionesData && sucursalesData && lineasData ? (
        <div className="peb-container">
          <div className="pebc-embudo">
            <div className="total-cotizaciones">
              Total de cotizaciones: {datosFiltrados.length}
            </div>
            <div className="leyenda-cotizaciones">
              {leyenda}
            </div>
            <div className="pebc-embudo-section scroll">
              <SectionEmbudo
                fases={fasesAplicadas.length > 0 ? fasesAplicadas.map(f => fasesMap[f] || f) : Object.values(fasesMap)}
                datos={datosFiltradosPorFase}
              />
            </div>
          </div>
          <div className="pebc-detalle">
            <FiltroTiempoRealSection
              visualizacion={visualizacion}
              onVisualizacionChange={setVisualizacion}
              dataRegiones={(regionesData) ? regionesData : []}
              dataSucursales={(sucursalesData) ? sucursalesData : []}
              dataLineas={(lineasData) ? lineasData : []}
              region={region}
              onRegionChange={setRegion}
              sucursal={sucursal}
              onSucursalChange={setSucursal}
              verpor={verpor}
              onverporchange={setVerpor}
              rol={rol}
            />
            <TablaEmbudo
              visualizacion={visualizacion}
              data={datosFiltradosPorFase}
              lineas={lineasDisponibles}
              verpor={verpor}
            />
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </PlantillaScreen>
  );
};
